import { Progress as ProgressPrimitive } from "radix-ui"
import type { ComponentProps } from "react"
import { cn } from "cn"

export type ProgressProps = ComponentProps<typeof ProgressPrimitive.Root> & {
  /** Titel des aktuellen Schritts, z. B. "Zur Person". */
  title?: string
  /** Schritt-Zähler, z. B. "1 von 3". */
  step?: string
  /** Blendet die Titel-/Schritt-Zeile über dem Balken ein oder aus. */
  showText?: boolean
}

function Progress({
  className,
  value,
  title,
  step,
  showText = true,
  ...props
}: ProgressProps) {
  return (
    <div
      data-slot="progress"
      className={cn("flex w-full flex-col gap-2", className)}
    >
      {showText && (title || step) && (
        <div
          data-slot="progress-label"
          className="flex items-baseline gap-1 text-sm whitespace-nowrap"
        >
          {title && (
            <span className="font-semibold text-labels-primary">{title}</span>
          )}
          {step && <span className="text-labels-secondary">{step}</span>}
        </div>
      )}
      <ProgressPrimitive.Root
        data-slot="progress-track"
        value={value}
        className="relative h-2 w-full overflow-hidden rounded-full bg-neutrals-v2-400"
        {...props}
      >
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className="h-full w-full flex-1 rounded-full bg-brand-red-200 transition-transform"
          style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
      </ProgressPrimitive.Root>
    </div>
  )
}

export { Progress }
